export type CoTeacher = {
  teacher_id: number;
  user_id: number;
  name: string | null;
  email: string | null;
};

export type CoTeacherList = {
  teacher_id: number;
  coteaches_for_ids: number[];
  coteachers: CoTeacher[];
};

const j = async (r: Response) => {
  if (r.ok) return r.json();
  let err: unknown;
  try {
    err = await r.json();
  } catch {
    err = { error: r.statusText };
  }
  throw err;
};

export const coteachingErrorMessage = (e: unknown, fallback: string): string =>
  (e as { detail?: string })?.detail ??
  (e as { error?: string })?.error ??
  fallback;

export const getCoteachers = (teacherId: number): Promise<CoTeacherList> =>
  fetch(`/api/proxy/teachers/${teacherId}/coteachers`).then(j);

export const searchCoteacherCandidates = (
  teacherId: number,
  query: string,
): Promise<CoTeacher[]> =>
  fetch(
    `/api/proxy/teachers/${teacherId}/coteacher-candidates?q=${encodeURIComponent(query)}`,
  ).then(j);

export const searchOrgTeacherCandidates = (
  organizationId: string,
  query: string,
): Promise<CoTeacher[]> =>
  fetch(
    `/api/proxy/organizations/${encodeURIComponent(organizationId)}/teacher-candidates?q=${encodeURIComponent(query)}`,
  ).then(j);

export const updateCoteachers = (
  teacherId: number,
  coteachesForIds: number[],
): Promise<CoTeacherList> =>
  fetch(`/api/proxy/teachers/${teacherId}/coteachers`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ coteaches_for_ids: coteachesForIds }),
  }).then(j);
